export default __webpack_public_path__ + "static/media/forms-check-white.35f8d8e3.svg";